// What is waiting to sync, counted the same way by the sync indicator and the "Signal is back" banner (Decision 84 #1
// round 3, AT-029 / AT-095). A file still on the phone that a waiting or sending change refers to ("file:<id>" anywhere
// in its payload) is part of that change and is not counted again; every other waiting file counts on its own (a
// standalone pick, or the photo of a change that was rejected, is held or was removed). Counting reads the outbox
// payloads and the files' records only, never a file's bytes (db.fileBytes is not read).
import { db, type FileBlob } from "./db";

/** A file still waiting to upload: not on the server, and not refused by it (a refused file waits for the person). */
export const isWaiting = (f: FileBlob) => !f.uploaded && !f.failed_reason;

/** The files a payload refers to ("file:<id>"), however deeply nested. */
export function fileRefs(value: unknown, out: string[] = []): string[] {
  if (typeof value === "string" && value.startsWith("file:")) out.push(value.slice(5));
  else if (Array.isArray(value)) value.forEach((v) => fileRefs(v, out));
  else if (value && typeof value === "object") Object.values(value).forEach((v) => fileRefs(v, out));
  return out;
}

export type WaitingCount = { changes: number; files: number };

/** Changes waiting or being sent, and the waiting files none of them refers to. */
export async function waitingCount(): Promise<WaitingCount> {
  const ops = await db.outbox.where("status").anyOf("waiting", "sending").toArray();
  const referred = new Set(ops.flatMap((o) => fileRefs(o.payload)));
  const files = (await db.files.filter(isWaiting).primaryKeys()) as string[];
  return { changes: ops.length, files: files.filter((id) => !referred.has(id)).length };
}
